import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PropTypes from 'prop-types';
import styles from './style';
import './loader.css';

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      id: 0,
    };
    this.rmMsg = this.rmMsg.bind(this);
  }
  remove(arr, id) {
    this.arr = arr;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id === id) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }
  toaster(arr) {
    const newOptions = this.state.options;
    newOptions.push(arr);
    this.setState({ options: newOptions });
  }
  rmMsg(key) {
    const newOptions = this.state.options;
    const newarr = this.remove(newOptions, key);
    this.setState({ options: newarr });
  }
  render() {
    let contbg = '';
    if (this.state.options.length > 0) {
      contbg = (<div style={styles.boxbg} >1</div>);
    }
    const cell = (
      <div style={styles.loadContainer}>
        <div className="loader">Loading...</div>
      </div>
    );
    return (
      <div style={styles.container} >
        <ReactCSSTransitionGroup
          transitionName="carousel"
          transitionEnterTimeout={400}
          transitionLeaveTimeout={400}
        >
          {cell}
          {contbg}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

Loader.propTypes = {
  callbackRM: PropTypes.func
  // style: PropTypes.shape({})
};

Loader.defaultProps = {
  options: [],
  callbackRM: () => {}
};

export default Loader;



// WEBPACK FOOTER //
// ./src/Components/Loader/loader.js